import Head from 'next/head'
import { LanguageContext } from '../hook/context'
import { useContext } from 'react'

const About = () => {
  const { t } = useContext(LanguageContext)
  return (
    <div className='my-14 text-neutral-400 max-w-4xl'>
      <Head>
        <title>
          {t.about.title} | {t.seo.title}
        </title>
      </Head>
      <h1 className='text-2xl font-bold tracking-tighter text-neutral-50'>
        {t.about.title}
      </h1>
      <p className=' mt-3'>{t.about.description}</p>
      <br />
      <p>{t.about.description2}</p>
      <br />
      <h2 className='text-3xl font-bold text-neutral-50'>
        {t.about.visionTitle}
      </h2>
      <p className='mt-3'>{t.about.visionDescription}</p>
      <br />
      <h2 className='text-3xl font-bold text-neutral-50'>
        {t.about.missionTitle}
      </h2>
      <p className='mt-3'>{t.about.missionDescription}</p>
      <ul className='list-disc mt-2 list-inside  -indent-[1.4rem] ml-6 marker:text-red-500'>
        {t.about.missionList.map((item: any, index: number) => (
          <li key={index}>{item.mark}</li>
        ))}
      </ul>
    </div>
  )
}

export default About
